import { SpecialAddonItem } from "../../../../pages/AddLeads/stepThree/Components/SpecialAddon";

interface ISsrSection {
  ssrData: SpecialAddonItem[];
}

const SsrSection: React.FC<ISsrSection> = ({ssrData}) => {

  return (
    <div className="ssr-section-wrapper flex gap-8">
      <div className="paid-ssr-section-wrapper border-1 rounded-md p-3 flex flex-col gap-4 w-1/3">
        <span className="text-xl font-medium text-[#3a3a3a]">Paid Special Services</span>
        <div className="paid-ssr-items-wrapper flex flex-col gap-2.5">
          {ssrData?.map((ssrItem) => {
            return (
              !!ssrItem?.price && (
                <div key={ssrItem?.id} className="paid-ssr-item-wrapper border-1 px-3 py-1.5 flex justify-between">
                  <span className="text-base font-medium text-[#3a3a3a]">{ssrItem?.name}</span>
                  <span className="text-base font-medium text-[#3a3a3a]">₹{ssrItem?.price}</span>
                </div>
              )
            );
          })}
        </div>
      </div>
      <div className="free-ssr-section-wrapper border-1 rounded-md p-3 flex flex-col gap-4 w-1/3">
        <span className="text-xl font-medium text-[#3a3a3a]">Free Special Services</span>
        <div className="free-ssr-items-wrapper flex flex-col gap-2.5">
          {ssrData?.map((ssrItem) => {
            return (
              !ssrItem?.price && (
                <div key={ssrItem?.id} className="free-ssr-item-wrapper border-1 px-3 py-1.5 flex justify-between">
                  <span className="text-base font-medium text-[#3a3a3a]">{ssrItem?.name}</span>
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SsrSection;
